import { Controller } from "stimulus";
import OpInview from './../components/opInview/opInview';

const CLASS_BG_LIGHT = 'is-bg-light';

export default class extends Controller {
    static targets = [ 'main', 'content' ];

    initialize() {
        this.switchToDark = this.switchToDark.bind(this);
        this.switchToLight = this.switchToLight.bind(this);
    }

    connect() {
        this.mainInview = new OpInview(this.contentTarget, {
            start: .05,
            end: 2,
            deactivate: true,
            activateCallback: this.switchToLight,
            deactivateCallback: this.switchToDark
        });

        // console.log("Hello, Stimulus!", element);
    }

    switchToDark() {
        this.element.classList.remove(CLASS_BG_LIGHT);
    }

    switchToLight() {
        this.element.classList.add(CLASS_BG_LIGHT);
    }
}


// WEBPACK FOOTER //
// ./mysite/resources/js/controllers/homepage_controller.js